/**
 * Labels geográficos (Guatemala) para el review del expediente: envuelve el resolvedor
 * compartido `@/shared/catalogs/geo` con el fallback y casing del review — "—" para vacío y
 * MAYÚSCULA para uniformar con el resto de los campos (el catálogo trae el municipio
 * capitalizado). La desambiguación municipio-por-(department, code) vive en el util compartido.
 */
import { departmentName, municipalityName } from '@/shared/catalogs/geo'

const EMPTY = '—'

/** Código de departamento → nombre (MAYÚSCULA, como el catálogo). */
export function departmentLabel(value: unknown): string {
  if (value == null || value === '') return EMPTY
  return departmentName(value) ?? String(value)
}

/**
 * Código de municipio → nombre. `department` desambigua los códigos que colisionan.
 * Devuelve el nombre en MAYÚSCULA.
 */
export function municipalityLabel(value: unknown, department?: unknown): string {
  if (value == null || value === '') return EMPTY
  const name = municipalityName(value, department)
  return name ? name.toUpperCase() : String(value)
}
